import { plainToInstanceWithLVS } from '@goparrot/common';
import { StoreItemComboListResponseDto, UpdateRelationsResponseDto } from '../dto';
import { ReadCategoryDto, ReadStoreItemComboDto } from '../generated-dto';
import { plainToClassMixedTypes } from '../utils';
import { BaseStoreItemFacade } from './BaseStoreItemFacade';
export class MerchantStoreItemComboFacade extends BaseStoreItemFacade {
    async list(merchantId, pagination, params) {
        const requestConfig = { params: { ...pagination, ...params } };
        return plainToInstanceWithLVS(StoreItemComboListResponseDto, (await this.client.get(this.buildBaseUrl(merchantId), requestConfig)).data, this.defaultTransformOptions);
    }
    async get(merchantId, uniqueName) {
        return plainToInstanceWithLVS(ReadStoreItemComboDto, (await this.client.get(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}`)).data, this.defaultTransformOptions);
    }
    async getParents(merchantId, uniqueName) {
        return plainToInstanceWithLVS(ReadCategoryDto, (await this.client.get(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/parents`)).data, this.defaultTransformOptions);
    }
    async getChildren(merchantId, uniqueName) {
        return plainToClassMixedTypes((await this.client.get(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/children`)).data);
    }
    async create(merchantId, data) {
        return plainToInstanceWithLVS(ReadStoreItemComboDto, (await this.client.post(this.buildBaseUrl(merchantId), data)).data, this.defaultTransformOptions);
    }
    async update(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(ReadStoreItemComboDto, (await this.client.put(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}`, data)).data, this.defaultTransformOptions);
    }
    async patch(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(ReadStoreItemComboDto, (await this.client.patch(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}`, data)).data, this.defaultTransformOptions);
    }
    async delete(merchantId, uniqueName) {
        await this.client.delete(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}`);
    }
    async clone(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(ReadStoreItemComboDto, (await this.client.post(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/clone`, data)).data, this.defaultTransformOptions);
    }
    async updateProperties(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(UpdateRelationsResponseDto, (await this.client.put(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/properties`, data)).data, this.defaultTransformOptions);
    }
    async updateCategories(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(UpdateRelationsResponseDto, (await this.client.put(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/categories`, data)).data, this.defaultTransformOptions);
    }
    async updateItemSets(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(UpdateRelationsResponseDto, (await this.client.put(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/item-sets`, data)).data, this.defaultTransformOptions);
    }
    async updateMods(merchantId, uniqueName, data) {
        return plainToInstanceWithLVS(ReadStoreItemComboDto, (await this.client.put(`${this.buildBaseUrl(merchantId)}/${encodeURIComponent(uniqueName)}/mods`, data)).data, this.defaultTransformOptions);
    }
    buildBaseUrl(merchantId) {
        return `/api/v2/merchants/${encodeURIComponent(merchantId)}/combos`;
    }
}
//# sourceMappingURL=MerchantStoreItemComboFacade.js.map